import React from 'react';

import { PageContent } from '../../article/styles';
import type { PrismicSliceHeroTitle } from 'src/types';

import { Hero as HeroContainer, TextContent, Title, SubTitle } from './styles';

const Hero = ({
  textColor,
  heroImage,
  title,
  secondaryTitle,
  textAlign,
  heroBackgroundColor,
}: PrismicSliceHeroTitle) => {
  return (
    <HeroContainer
      textColor={textColor}
      heroImage={heroImage}
      heroBackgroundColor={heroBackgroundColor}
    >
      <PageContent alignLeft>
        <TextContent>
          <Title data={title} textAlign={textAlign} />
          <SubTitle data={secondaryTitle} textAlign={textAlign} />
        </TextContent>
      </PageContent>
    </HeroContainer>
  );
};

export default Hero;
